/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { ERC1967Proxy__factory } from "./ERC1967Proxy__factory";
export { ERC1967Upgrade__factory } from "./ERC1967Upgrade__factory";
